module.exports = __webpack_public_path__ + "static/img/pinpai-27.da128a20.png";